<div class="webdoku">
  @if (webDoku.redliningAllowed && webDoku.isSubWebDoku) {
    <span>&nbsp;&nbsp;&nbsp;</span>
    <div class="iconsub"><mat-icon>topic</mat-icon></div>
  }
  @if (webDoku.redliningAllowed && !webDoku.isSubWebDoku) {
    <div class="icon"><mat-icon>topic</mat-icon></div>
  }
  @if (!webDoku.redliningAllowed && webDoku.isSubWebDoku) {
    <span>&nbsp;&nbsp;&nbsp;</span>
    <div class="iconsub"><mat-icon>lock_outlined</mat-icon></div>
  }

  @if (!webDoku.redliningAllowed && !webDoku.isSubWebDoku) {
    <div class="icon"><mat-icon>lock_outlined</mat-icon></div>
  }
  <div class="doku">
    <div class="bigtext">{{ webDoku.text }}</div>
    @if (showDescription()) {
      <div class="text mat-small">{{ webDoku.description }}</div>
    }
  </div>
  @if (hasStatus()) {
    <div class="status" [style]="getBorderStyle()">
      <div class="statusLabel mat-small" [style]="getStatusStyle()">{{ webDoku.statusTitle }}</div>
      <div class="statusLabel mat-small" [style]="getStatusStyle()">{{ webDoku.statusSubTitle }}</div>
    </div>
  }
</div>
